const formRestoreEquipment = {
  text: 'Do you really want to restore the equipment',
  text2: 'All Services and Actions related to that equipment will be restored.',
  title: 'RESTORE EQUIPMENT',
  buttonText: 'RESTORE DELETED EQUIPMENT',
};

export default formRestoreEquipment;